import { Controller } from "@hotwired/stimulus"
import {translate as t} from 'common/i18n'
import $ from 'jquery'
import toastr from 'toastr'
toastr.options = {"closeButton": true, "progressBar": true, "timeOut": "10000" }

export default class extends Controller {
  static targets = [
    'form',
    'dialog',
    'passwords',
    'confirm',
    'password',
    'confirmPassword',
    'authForm',
    'closeBtn',
    'confirmBtn',
    'errors',
  ]
  static values = {
    url: String,
    reload: Boolean,
  }

  connect() {
    $(this.dialogTarget).on('closed.zf.reveal', ()=> this.dispatch("reload", {prefix: false}))
  }

  async start() {
    this.formTarget.reset()
    this.passwordsTarget.classList.remove('hide')
    this.confirmTarget.classList.add('hide')
    $(this.dialogTarget).foundation('open')
  }

  async perform() {
    const data = new FormData(this.formTarget)
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    this.#clearErrors()

    this.#beginLoad()
    const response = await fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken,
      },
      body: data,
    })

    if (response.ok) {
      toastr.success(t('users.change_password.success'))
      $(this.dialogTarget).foundation('close')
      if (this.reloadValue) {
        this.dispatch("reload", {prefix: false})
      } else {
        window.location.reload()
      }
    } else if (response.status === 422) {
      const {error, messages} = await response.json()
      this.#setErrors(messages)
    } else if (response.status === 403) {
      // ask for otp or password
      // Credential = 'otp' | 'current_password'
      // {error: String, credentials: Credential[]}
      const {error, messages, credentials} = await response.json()
      
      this.authFormTarget.dataset['users-AuthenticationFormMethodsValue'] = JSON.stringify(credentials)
      this.authFormTarget.dataset['users-AuthenticationFormErrorsValue'] = JSON.stringify(messages)
      this.passwordsTarget.classList.add('hide')
      this.confirmTarget.classList.remove('hide')

      this.#setErrors(messages)
    }

    this.#endLoad()
  }

  #setErrors(messages = []) {
    if(messages.length > 0) {
      this.errorsTarget.classList.remove('hide')
      this.errorsTarget.innerHTML = messages.join('<br>')
    } else {
      this.errorsTarget.classList.add('hide')
    }
  }

  #clearErrors() {
    this.errorsTarget.classList.add('hide')
  }

  #beginLoad() {
    if(!this._mask) {
      this._mask = document.createElement('div')
      this._mask.classList.add('loading-mask')
      this._mask.innerHTML = '<i class="fas fa-spinner fa-3x fa-spin"></i>'
      this.dialogTarget.appendChild(this._mask)
    }
  }

  #endLoad() {
    if(this._mask) {
      this._mask.remove()
      this._mask = null
    }
  }
}
